import { useUnconstraintForecast } from 'screens/FDPScreen/components/UnconstraintForecastScreen/useUnconstraintForecast';
import classes from './unconstraintForecastview.module.scss';
import { TabPanel, TabView } from 'primereact/tabview';
import NDCHeader from '../NDCHeader';
import { observer } from 'mobx-react';
import UnconstrainedForecastLoadingSkeleton from './components/UnconstrainedForecastViewSkeleton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { unconstrainedForecastAllowedRoles } from 'data/fdp/fdpUserRolesValidations';
import ConceptDetailsSkeleton from 'screens/FDP/components/ConceptDetailsSkeleton';
import ConceptDetailsSection from 'screens/FDP/components/ConceptDetails';
import NotesSection from 'screens/FDPScreen/components/NotesSection';
import { Accordion, AccordionTab } from 'primereact/accordion';

const UnconstraintForecastView = () => {
  const {
    userModulesRoles,
    forecastingMonthsView,
    conceptDetails,
    isConceptLoading,
    isInvoiceSalesLoading,
    isunconstrainedForecastDataLoading,
    directcurrentNDCIndex,
    indirectcurrentNDCIndex,
    directNDCheading,
    indirectNDCheading,
    isUnconstrainedForecastNotesDataLoading,
    unconstrainedForecastData,
    unconstrainedForecastStatus,
    unconstrainedForecastPlanningPeriods,
    unconstrainedPeriod,
    unconstrainedForecastPlanningPeriodLoading,
    isDirectMode,
    contractDetails,
    forecastBtnLabel,
    UnconstrainedForecastStatusLoading,
    handleDirectCurrentTabIndex,
    handleIndirectNDCTabChange,
    getInvoiceSalesDetails,
    getStratCode,
    getBaseline,
    getAdjustments,
    handleOptionChange,
    setIsDirectMode,
    UnconstrainedForecastNotesData,
  } = useUnconstraintForecast();

  return (
    <div
      className={`${classes.viewContainer} ${
        conceptDetails?.gfc === 0 && !isConceptLoading && classes.displayNone
      }`}
    >
      <div className={classes.conceptContainer}>
        <div className={classes.heading}>
          <h2>Unconstrained Forecast</h2>
        </div>
        <div style={{ width: '100%' }}>
          {isConceptLoading ? (
            <ConceptDetailsSkeleton />
          ) : (
            <ConceptDetailsSection
              conceptDetails={conceptDetails}
              contractDetails={contractDetails}
              isDisabled={
                UnconstrainedForecastStatusLoading ||
                !checkIfFunctionalityEnabled(
                  unconstrainedForecastAllowedRoles.createNewPlanButton,
                  userModulesRoles.fdp,
                  userModulesRoles
                )
              }
              path={`edit/${conceptDetails?.gfc}`}
              label={forecastBtnLabel}
              loading={unconstrainedForecastStatus}
            />
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '1rem', padding: '.5rem' }}>
        <div className={classes.forecastCard}>
          <div className={classes.plan}>
            <div>
              <span>
                Choose Plan:{' '}
              </span>
            </div>
            <div className={classes.planningPeriodDropdown}>
              <Dropdown
                disabled={unconstrainedForecastPlanningPeriods.length === 0}
                value={unconstrainedPeriod}
                options={unconstrainedForecastPlanningPeriods}
                optionLabel="label"
                onChange={e => {
                  handleOptionChange(e.value);
                }}
                style={{ width: '15rem' }}
                loading={unconstrainedForecastPlanningPeriodLoading}
              />
            </div>
          </div>
          {isunconstrainedForecastDataLoading ? (
            <UnconstrainedForecastLoadingSkeleton />
          ) : unconstrainedForecastData.forecasts.length > 0 ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  margin: '1rem',
                }}
              >
                {directNDCheading.length > 0 && (
                  <Accordion activeIndex={0} onClick={() => setIsDirectMode(true)}>
                    <AccordionTab header="Direct">
                      <div
                        style={{ display: `${!isDirectMode ? 'none' : ''}` }}
                        className={classes.directtabContainer}
                      >
                        {/* tab view for direct selling category */}
                        {directNDCheading.length > 0 ? (
                          <TabView
                            scrollable
                            tabIndex={directcurrentNDCIndex}
                            onTabChange={handleDirectCurrentTabIndex}
                          >
                            {directNDCheading?.map((ndc, index) => (
                              <TabPanel
                                key={index}
                                header={
                                  <NDCHeader
                                    heading={ndc.ndc}
                                    isSelected={directcurrentNDCIndex === index}
                                    tabIndex={index}
                                  />
                                }
                              >
                                <div className={classes.contentContainer}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '5rem',
                                      padding: '1rem',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <div>
                                      <p>
                                        Pack Size:{' '}
                                        <span>
                                          {directNDCheading[directcurrentNDCIndex]?.packSize}
                                        </span>
                                      </p>
                                    </div>
                                    <div className={classes.saleDetails}>
                                      <div>
                                        <div
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            paddingLeft: '3rem',
                                          }}
                                        >
                                          YTD:{' '}
                                          {!isInvoiceSalesLoading ? (
                                            getInvoiceSalesDetails(
                                              directNDCheading[directcurrentNDCIndex].ndc,
                                              'ytd'
                                            )
                                          ) : (
                                            <ProgressSpinner
                                              style={{
                                                width: '10px',
                                                height: '10px',
                                                padding: 0,
                                                margin: 0,
                                              }}
                                              strokeWidth="8"
                                              fill="var(--surface-ground)"
                                              animationDuration="1s"
                                            />
                                          )}
                                        </div>
                                        <div className={classes.vertical}></div>
                                        <div
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                          }}
                                        >
                                          3MA:{' '}
                                          {!isInvoiceSalesLoading ? (
                                            getInvoiceSalesDetails(
                                              directNDCheading[directcurrentNDCIndex].ndc,
                                              '3ma'
                                            )
                                          ) : (
                                            <ProgressSpinner
                                              style={{
                                                width: '10px',
                                                height: '10px',
                                                padding: 0,
                                                margin: 0,
                                              }}
                                              strokeWidth="8"
                                              fill="var(--surface-ground)"
                                              animationDuration="1s"
                                            />
                                          )}
                                        </div>
                                        <div className={classes.vertical}></div>
                                        <div
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            paddingRight: '3rem',
                                          }}
                                        >
                                          PM:{' '}
                                          {!isInvoiceSalesLoading ? (
                                            getInvoiceSalesDetails(
                                              directNDCheading[directcurrentNDCIndex].ndc,
                                              'pm'
                                            )
                                          ) : (
                                            <ProgressSpinner
                                              style={{
                                                width: '10px',
                                                height: '10px',
                                                padding: 0,
                                                margin: 0,
                                              }}
                                              strokeWidth="8"
                                              fill="var(--surface-ground)"
                                              animationDuration="1s"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.forecastTable}>
                                    <table>
                                      <thead>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Forecast Period</td>
                                        </th>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Strat Code</td>
                                        </th>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Baseline</td>
                                        </th>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Adj Forecast</td>
                                        </th>
                                      </thead>
                                      <tbody>
                                        {forecastingMonthsView.map((_, idx) => {
                                          return (
                                            <tr key={idx}>
                                              <td style={{ width: '18rem' }}>
                                                {forecastingMonthsView[idx].label}
                                              </td>
                                              <td
                                                style={{
                                                  color: '#7B4B9F',
                                                  fontWeight: '600',
                                                }}
                                              >
                                                {getStratCode(
                                                  directNDCheading[directcurrentNDCIndex].ndc,
                                                  forecastingMonthsView[idx].dateString
                                                )}
                                              </td>
                                              <td>
                                                {getBaseline(
                                                  directNDCheading[directcurrentNDCIndex].ndc,
                                                  forecastingMonthsView[idx].dateString
                                                )}
                                              </td>
                                              <td>
                                                {getAdjustments(
                                                  directNDCheading[directcurrentNDCIndex].ndc,
                                                  forecastingMonthsView[idx].dateString
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </TabPanel>
                            ))}
                          </TabView>
                        ) : (
                          <div
                            style={{
                              height: '20rem',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '2rem',
                              margin: 'auto',
                            }}
                          >
                            No Unconstrained Forecast data available for Direct Selling Category.
                          </div>
                        )}
                      </div>
                    </AccordionTab>
                  </Accordion>
                )}

                {indirectNDCheading.length > 0 && (
                  <Accordion
                    onClick={() => setIsDirectMode(false)}
                    activeIndex={directNDCheading.length === 0 ? 0 : null}
                  >
                    <AccordionTab header="Indirect">
                      <div className={classes.directtabContainer}>
                        {/* tab view for indirect selling category */}
                        {indirectNDCheading.length > 0 ? (
                          <TabView
                            scrollable
                            tabIndex={indirectcurrentNDCIndex}
                            onTabChange={handleIndirectNDCTabChange}
                          >
                            {indirectNDCheading.map((ndc, index) => (
                              <TabPanel
                                key={index}
                                header={
                                  <NDCHeader
                                    heading={ndc.ndc}
                                    isSelected={indirectcurrentNDCIndex === index}
                                    tabIndex={index}
                                  />
                                }
                              >
                                <div className={classes.contentContainer}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '5rem',
                                      marginBottom: '1rem',
                                      padding: '1rem',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <div>
                                      <p>
                                        Pack Size:{' '}
                                        <span>
                                          {indirectNDCheading[indirectcurrentNDCIndex]?.packSize}
                                        </span>
                                      </p>
                                    </div>
                                    <div className={classes.saleDetails}>
                                      <div>
                                        <div
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            paddingLeft: '3rem',
                                          }}
                                        >
                                          YTD:{' '}
                                          {!isInvoiceSalesLoading ? (
                                            getInvoiceSalesDetails(
                                              indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                              'ytd'
                                            )
                                          ) : (
                                            <ProgressSpinner
                                              style={{
                                                width: '10px',
                                                height: '10px',
                                                padding: 0,
                                                margin: 0,
                                              }}
                                              strokeWidth="8"
                                              fill="var(--surface-ground)"
                                              animationDuration="1s"
                                            />
                                          )}
                                        </div>
                                        <div className={classes.vertical}></div>
                                        <div
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                          }}
                                        >
                                          3MA:{' '}
                                          {!isInvoiceSalesLoading ? (
                                            getInvoiceSalesDetails(
                                              indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                              '3ma'
                                            )
                                          ) : (
                                            <ProgressSpinner
                                              style={{
                                                width: '10px',
                                                height: '10px',
                                                padding: 0,
                                                margin: 0,
                                              }}
                                              strokeWidth="8"
                                              fill="var(--surface-ground)"
                                              animationDuration="1s"
                                            />
                                          )}
                                        </div>
                                        <div className={classes.vertical}></div>
                                        <div
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            paddingRight: '3rem',
                                          }}
                                        >
                                          PM:{' '}
                                          {!isInvoiceSalesLoading ? (
                                            getInvoiceSalesDetails(
                                              indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                              'pm'
                                            )
                                          ) : (
                                            <ProgressSpinner
                                              style={{
                                                width: '10px',
                                                height: '10px',
                                                padding: 0,
                                                margin: 0,
                                              }}
                                              strokeWidth="8"
                                              fill="var(--surface-ground)"
                                              animationDuration="1s"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className={classes.forecastTable}>
                                    <table>
                                      <thead>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Forecast Period</td>
                                        </th>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Strat Code</td>
                                        </th>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Baseline</td>
                                        </th>
                                        <th>
                                          <td style={{ fontSize: '15px' }}>Adj Forecast</td>
                                        </th>
                                      </thead>
                                      <tbody>
                                        {forecastingMonthsView.map((_, idx) => {
                                          return (
                                            <tr key={idx}>
                                              <td style={{ width: '18rem' }}>
                                                {forecastingMonthsView[idx].label}
                                              </td>
                                              <td
                                                style={{
                                                  color: '#7B4B9F',
                                                  fontWeight: '600',
                                                }}
                                              >
                                                {getStratCode(
                                                  indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                                  forecastingMonthsView[idx].dateString
                                                )}
                                              </td>
                                              <td>
                                                {getBaseline(
                                                  indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                                  forecastingMonthsView[idx].dateString
                                                )}
                                              </td>
                                              <td>
                                                {getAdjustments(
                                                  indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                                  forecastingMonthsView[idx].dateString
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </TabPanel>
                            ))}
                          </TabView>
                        ) : (
                          <div
                            style={{
                              height: '20rem',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '2rem',
                            }}
                          >
                            No Unconstrained Forecast data available for Indirect selling category.
                          </div>
                        )}
                      </div>
                    </AccordionTab>
                  </Accordion>
                )}
              </div>
            </div>
          ) : (
            <div
              style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2rem',
              }}
            >
              No Unconstrained Forecast data found!!
            </div>
          )}
        </div>
        <NotesSection
          mode="view"
          isNotesDataLoading={
            isUnconstrainedForecastNotesDataLoading ||
            isConceptLoading ||
            isunconstrainedForecastDataLoading
          }
          notesData={UnconstrainedForecastNotesData}
        />
      </div>
    </div>
  );
};

export default observer(UnconstraintForecastView);
